import moment from "moment";
import dateFormats from "../system/dateFormats";
import TextBlock from "./Layout/TextBlock";
import { MailReference, TransportOrder } from "../system/Domain";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";

interface Props {
	emails: MailReference[]
}

const EmailCommunicationTable = (props: Props) => {
	const sorterEmails = props.emails?.sort((a, b) => moment(b.referenceCreated).valueOf() - moment(a.referenceCreated).valueOf()) ?? [];

	return (
		<Table>
			<TableBody>
				{sorterEmails.map((n, i) => (
					<TableRow key={i}>
						<TableCell sx={{ verticalAlign: "top", width: 1 / 4 }}>
							<TextBlock
								primary={moment(n.referenceCreated).format(dateFormats.dateTime)}
								secondary={moment(n.referenceCreated).fromNow()}
							/>
						</TableCell>
						<TableCell sx={{ verticalAlign: "top", width: 3 / 4 }}>
							<TextBlock
								primary={n.subject}
								secondary={n.to.join(", ")}
							/>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export default EmailCommunicationTable;
